<template>
    <div>
        <el-row class="layout-page-heading">
            <el-col :span="16">
                <h3>个人信息</h3>
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item>主页</el-breadcrumb-item>
                    <el-breadcrumb-item>个人信息</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
            <el-col :span="8">
                <div class="layout-page-heading-action">
                    <el-button onclick="router.go(-1)"><i class="fa fa-chevron-left"></i>返回</el-button>
                    <el-button type="primary" @click="save"><i class="fa fa-save"></i>保存</el-button>
                </div>
            </el-col>
        </el-row>
        <div class="layout-page-box">
            <el-form label-width="80px" label-position="right" :model="user" :rules="rules" ref="user" class="edit-form">
                <!--  <el-form-item label="账号" prop="account">
                    <el-input v-model="user.account" :disabled="true" placeholder="账号"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="nickname">
                    <el-input v-model="user.nickname" placeholder="姓名"></el-input>
                </el-form-item>
                <el-form-item label="邮箱">
                    <el-input v-model="user.email" placeholder="邮箱"></el-input>
                </el-form-item>-->
                <!-- <el-form-item label="角色">
                    <el-select
                            v-model="user.role_keys"
                            multiple
                            filterable
                            :disabled="true"
                            placeholder="请选择角色">
                        <el-option
                                v-for="item in roles"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="部门">
                    <el-cascader
                            change-on-select
                            :disabled="true"
                            :clearable="true"
                            :options="offices"
                            :props="{value: 'id',label: 'name'}"
                            v-model="user.office_keys">
                    </el-cascader>
                </el-form-item>-->
                <!--   <el-form-item label="联系电话">
                    <el-input v-model="user.mobile" placeholder="联系电话"></el-input>
                </el-form-item>-->
                <el-form-item label="密码">
                    <el-input type="password" v-model="user.oldpassword" placeholder="旧密码"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input type="password" v-model="user.newpassword" placeholder="新密码"></el-input>
                </el-form-item>
                <el-form-item label="密码">
                    <el-input type="password" v-model="user.newpassword1" placeholder="再次确认密码"></el-input>
                </el-form-item>
                <!--      <el-form-item label="工作状态">
                    <el-radio-group v-model="user.work_status">
                        <el-radio class="radio" :label="0">暂停进件</el-radio>
                        <el-radio class="radio" :label="1">正常进件</el-radio>
                        <el-radio class="radio" :label="-1">离线</el-radio>
                    </el-radio-group>
                </el-form-item>-->
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: {
                id: '',
                account: '',
                nickname: '',
                email: '',
                mobile: '',
                password: '',
                office_keys: [],
                role_keys: [],
                work_status: 0,
                oldpassword: '',
                newpassword: '',
                newpassword1: '',
            },
            roles: [],
            offices: [],
            /*         rules: {
                         account: [
                             {required: true, message: '请输入账号', trigger: 'blur'}
                         ],
                         nickname: [
                             {required: true, message: '请输入姓名', trigger: 'blur'},
                         ]
                     }*/
        }
    },
    methods: {
        save() {
            if (this.user.newpassword != this.user.newpassword1) {
                _g.toast('error', '请保持两次密码一致')
                return
            }
            if (this.user.oldpassword == '') {
                _g.toast("error", "不能为空")
                return
            }
            if (this.user.newpassword == '') {
                _g.toast("error", "不能为空")
                return
            }
            var data = {
                empId: this.user.id,
                oldPassword: md5(this.user.oldpassword),
                newPassword: md5(this.user.newpassword)
            }
            this.$refs.user.validate((valid) => {
                if (valid) {
                    api.request('employee/updateEmployee', data, (res) => {
                        if (res.result == true) {
                            _g.toast('success', '保存成功')
                            Lockr.flush()
                            router.push('/login')
                        } else {

                        }
                    }, (err) => {
                        _g.toast('error', '保存失败')
                    })
                }
            })
        },
        init() {
            var user_id = Lockr.get('userId');
            if (!user_id) {
                router.push('/login');
                return;
            }
            api.request('employee/findEmployeeById', { empId: user_id }, (res) => {
                this.user.id = res.data.empId;
                this.user.account = res.data.empName
                this.user.nickname = res.data.nickName
                this.user.email = res.data.email
                this.user.mobile = res.data.mobile
            }, (err) => { })

        }
    },
    mounted() {
        this.init()
    }
}
</script>

<style scoped>
</style>
